import { render, staticRenderFns } from "./CreateService.vue?vue&type=template&id=dc08288e&scoped=true"
import script from "./CreateService.vue?vue&type=script&lang=js"
export * from "./CreateService.vue?vue&type=script&lang=js"
import style0 from "./CreateService.vue?vue&type=style&index=0&id=dc08288e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc08288e",
  null
  
)

export default component.exports